
function sdDateFilterController($scope, MessageService, CommentsService) {
    var ctrl = this;

    /*******************************************************/
    /*  NOVO FILTRO DE DATAS                               */
    /*******************************************************/

    var monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    

    ctrl.getMonthName = function (month) {
        return monthNames[month];
    };

    ctrl.groupDates = function () {
        //console.log('groupDates');
        var yearOpen = true;
        var years = [];
        if (ctrl.options) {
            for (var i = 0; i < ctrl.options.length; i++) {
                if (ctrl.options[i].Value != null) {
                    var date = new Date(ctrl.options[i].Value);

                    var year = {
                        Value: date.getUTCFullYear(),
                        months: [],
                        isOpen: yearOpen
                    };

                    var canAddYear = true;
                    var yearIndex = 0;

                    for (var j = 0; j < years.length; j++) {
                        if (years[j].Value == year.Value) {
                            canAddYear = false;
                            yearIndex = j;
                        }
                    }

                    if (canAddYear) {
                        years.push(year);
                        yearIndex = years.indexOf(year);
                    }
                    var month = {
                        Value: date.getUTCMonth(),
                        days: []
                    };

                    var canAddMonth = true;
                    var monthIndex = 0;

                    for (var k = 0; k < years[yearIndex].months.length; k++) {
                        if (years[yearIndex].months[k].Value == month.Value) {
                            canAddMonth = false;
                            monthIndex = k;
                        }
                    }

                    if (canAddMonth) {
                        years[yearIndex].months.push(month);
                        monthIndex = years[yearIndex].months.indexOf(month);
                    }

                    var day = {
                        Value: date.getUTCDate(),
                    }

                    var canAddDay = true;

                    for (var l = 0; l < years[yearIndex].months[monthIndex].days.length; l++) {
                        if (years[yearIndex].months[monthIndex].days[l].Value == day.Value) {
                            canAddDay = false;
                        }
                    }

                    if (canAddDay)
                        years[yearIndex].months[monthIndex].days.push(day);

                    ctrl.years = years;
                }
            }
        }
    };

    $scope.$on('datesLoaded', function (event, options) {
        if (ctrl.options.length == 0) {
            ctrl.options = options;
            ctrl.groupDates();
        }
    });

    ctrl.dateState = function (obj, type) {

        if (type == 'year') {

            var daysChecked = 0;
            var totalDays = 0;

            for (var i = 0; i < obj.months.length; i++) {
                if (obj.months[i]) {

                    for (var j = 0; j < obj.months[i].days.length; j++) {
                        totalDays++;
                        if (obj.months[i].days[j].isChecked)
                            daysChecked++;
                    }

                }
            }

            if (daysChecked == 0) {
                return 'none';
            }
            else if (daysChecked == totalDays) {
                return 'all';
            }
            else {
                return 'partial';
            }

        } else if (type == 'month') {

            var monthsChecked = 0;
            for (var k = 0; k < obj.days.length; k++) {
                if (obj.days[k].isChecked)
                    monthsChecked++;
            }

            if (monthsChecked == 0)
                return 'none';
            else if (monthsChecked == obj.days.length)
                return 'all';
            else
                return 'partial';
        }

    };

    ctrl.changeDateState = function (obj, type) {

        if (type == 'all') {
            if (ctrl.selectAllDates() != 'all') {
                for (var i = 0; i < obj.length; i++) {
                    for (var j = 0; j < obj[i].months.length; j++) {
                        for (var k = 0; k < obj[i].months[j].days.length; k++) {
                            obj[i].months[j].days[k].isChecked = true;
                        }
                    }
                }
            } else {
                var years = ctrl.years;

                for (var l = 0; l < years.length; l++) {
                    for (var m = 0; m < years[l].months.length; m++) {
                        for (var n = 0; n < years[l].months[m].days.length; n++) {
                            years[l].months[m].days[n].isChecked = false;
                        }
                    }
                }

                ctrl.years = years;
            }
        }

        if (type == 'year') {

            if (ctrl.dateState(obj, type) == 'all') {
                for (var o = 0; o < obj.months.length; o++) {
                    obj.months[o].isChecked = false;

                    for (var p = 0; p < obj.months[o].days.length; p++) {
                        obj.months[o].days[p].isChecked = false;
                    }

                }
            } else {
                for (var q = 0; q < obj.months.length; q++) {
                    obj.months[q].isChecked = true;

                    for (var r = 0; r < obj.months[q].days.length; r++) {
                        obj.months[q].days[r].isChecked = true;
                    }

                }
            }

        } else if (type == 'month') {

            if (ctrl.dateState(obj, type) == 'all') {
                for (var s = 0; s < obj.days.length; s++) {
                    obj.days[s].isChecked = false;
                }
            } else {
                for (var t = 0; t < obj.days.length; t++) {
                    obj.days[t].isChecked = true;
                }
            }

        } else {
            obj.isChecked = !obj.isChecked;
        }

    };

    ctrl.selectAllDates = function () {
        if (ctrl.years) {

            var years = ctrl.years;
            var totalDays = 0;
            var daysChecked = 0;

            for (var i = 0; i < years.length; i++) {
                for (var j = 0; j < years[i].months.length; j++) {
                    for (var k = 0; k < years[i].months[j].days.length; k++) {
                        totalDays++;
                        if (years[i].months[j].days[k].isChecked == true)
                            daysChecked++;
                    }
                }
            }

            if (totalDays == daysChecked)
                return 'all';
            else if (daysChecked == 0)
                return 'none';
            else
                return 'partial';

        }
    };
    ctrl.groupDates();

    ctrl.fillZeros = function (number) {
        if (ctrl.isNumber(number)) {
            var str = ("0" + number).slice(-2);
            return str;
        }
        else {
            return number;
        }
    };

    ctrl.isNumber = function (value) {
        return typeof value === 'number' && isFinite(value);
    };
}

sdDateFilterController.$inject = ['$scope', 'MessageService', 'CommentsService'];

seedWebApp.component('sdDateFilter', {
    controller: sdDateFilterController,
    bindings: {
        years: '=',
        options: '=',
    },
    templateUrl: '/SPA/Components/serviceGrid/sd-date-filter.html' + seedWebApp.buildVersion,
});